<template>
  <div class="container_spinner_live">
    <b-icon icon="arrow-clockwise" animation="spin" font-scale="1.5"></b-icon>
    <!-- <p>{{ temps_de_course }}</p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      temps_de_course: "",
    };
  },
  methods: {
    tempsCourseRefresh() {
      /* if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshTempsCourseIntervals");
        return;
      } */

      var _this = this;

      _this.$store.commit("clearRefreshTempsCourseIntervals");
      if (!_this.$store.state.date_selected_course || !_this.$store.state.heure_selected_course) {
        return;
      }

      var date_depart = _this.$store.state.date_selected_course.split("-");
      var heure_depart = _this.$store.state.heure_selected_course.split(":");
      if (date_depart.length > 2 && heure_depart.length > 2) {
        var timestamp_depart = new Date(date_depart[2], parseInt(date_depart[1]) - 1, date_depart[0], heure_depart[0], heure_depart[1], heure_depart[2]);
        var timestamp_now = Date.now();
        var temps_course = (timestamp_now - timestamp_depart) / 1000;
        _this.temps_de_course = _this.seconds2time(parseInt(temps_course));
        _this.$forceUpdate();
      }
      var intervalObject = setInterval(function () {
        _this.tempsCourseRefresh();
      }, 1000);
      this.$store.state.refreshTempsCourseIntervals.push(intervalObject);
    },

    seconds2time(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      var seconds = seconds - hours * 3600 - minutes * 60;
      var time = "";

      if (hours != 0) {
        hours = hours < 10 ? "0" + hours : String(hours);
        time = hours + ":";
      }
      if (minutes != 0 || time !== "") {
        minutes = minutes < 10 && time !== "" ? "0" + minutes : String(minutes);
        time += minutes + ":";
      }
      if (time === "") {
        time = seconds + "s";
      } else {
        time += seconds < 10 ? "0" + seconds : String(seconds);
      }

      return time;
    },
  },
  mounted() {
    this.tempsCourseRefresh();
    this.$forceUpdate();
  },
};
</script>

<style lang="scss" scoped></style>